import { AuthenticationService } from './../../shared/authentication.service';
import { QualityTicketService } from './../../shared/qualityticketqueue.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-qualityticket',
  templateUrl: './qualityticket.component.html',
  styleUrls: ['./qualityticket.component.scss']
})
export class QualityticketComponent implements OnInit {

  constructor(
    private queueService: QualityTicketService,
    public authService: AuthenticationService,
    private _router: Router
  ) { }

  ngOnInit() {
  }

  getnextexternal() {
    this._router.navigate(['/ticket/nextexternal']);
  }
  getnextinternal() {
    this._router.navigate(['/ticket/nextinternal']);
  }

}
